import { render, staticRenderFns } from "./kmDataTable.vue?vue&type=template&id=78d641d4"
import script from "./kmDataTable.vue?vue&type=script&lang=js"
export * from "./kmDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports